/**
 * Money, for display to an employee.
 *
 * Employee pay is set per position and is always a whole number of dollars in
 * practice, and ".00" on every figure is noise that makes a column harder to
 * scan. So whole amounts lose the decimals.
 *
 * Fractional amounts keep them. Rounding would be the tidier rule, but it
 * would also mean a screen quietly reporting a different number from the one
 * being paid, and being tidy is not worth that. If cents ever do appear, they
 * are shown.
 */
export function formatPay(amount: number): string {
  const safe = Number.isFinite(amount) ? amount : 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: Number.isInteger(safe) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(safe);
}
